import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import { BASE_URL } from "../config/apiconfig";
import { useAuth } from "./AuthContext";

const ProductShapeContext = createContext();
export const useProductShapes = () => useContext(ProductShapeContext);

export const ProductShapeProvider = ({ children }) => {
  const { token, adminId } = useAuth();
  const [shapes, setShapes] = useState([]);
  const [shapeloading, setLoading] = useState(false);

  const fetchShapes = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/product-shapes`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const json = await res.json();
      setShapes(json.data || []);
    } finally {
      setLoading(false);
    }
  }, [token]);

  const addShape = async (data) => {
    await fetch(`${BASE_URL}/product-shapes`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, create_audit_id: adminId }),
    });
    fetchShapes();
  };

  const updateShape = async (id, data) => {
    await fetch(`${BASE_URL}/product-shapes/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...data, update_audit_id: adminId }),
    });
    fetchShapes();
  };

  const toggleStatus = async (id, status) => {
    await fetch(`${BASE_URL}/product-shapes/${id}/status`, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        status: status === "Active" ? "Inactive" : "Active",
        update_audit_id: adminId,
      }),
    });
    fetchShapes();
  };

  const deleteShape = async (id) => {
    await fetch(`${BASE_URL}/product-shapes/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    fetchShapes();
  };

  useEffect(() => {
    fetchShapes();
  }, [fetchShapes]);

  return (
    <ProductShapeContext.Provider
      value={{
        shapes,
        shapeloading,
        addShape,
        updateShape,
        toggleStatus,
        deleteShape,
      }}
    >
      {children}
    </ProductShapeContext.Provider>
  );
};
